import { useRef, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { useWindowSize } from 'usehooks-ts'

import { useEffect } from 'modules/core/hooks/useEffect'

import InboxList from 'modules/inbox_tasks/components/InboxList'
import useOpenTaskFromParams from 'modules/inbox_tasks/hooks/useOpenTaskFromParams'

const TodoTasksPage = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  const [availableHeight, setAvailableHeight] = useState<number>()

  const size = useWindowSize()

  useOpenTaskFromParams()

  useEffect(() => {
    setAvailableHeight(containerRef.current?.parentElement?.offsetHeight)
  }, [size.height])

  return (
    <Box
      ref={containerRef}
      paddingX="s8"
      paddingTop="s20"
      style={availableHeight ? { height: `${availableHeight}px` } : undefined}
    >
      {availableHeight ? <InboxList /> : null}
    </Box>
  )
}

export default TodoTasksPage
